import React from 'react';
import PropTypes from 'prop-types';

import AbstractFunnel from "@components/abstract_funnel";
import withLoader from '@components/common/with_loader_decorator';
import withHistory from '@components/common/with_history_decorator'
import withPhoneCollector from '@components/common/with_phone_collector_decorator'
import Authenticator from '@components/common/authenticator'

import FunnelStatePersistance from '@services/funnel_state_persistance'

class WindowCleaningFunnel extends AbstractFunnel {
    static childContextTypes = {
        locationStrategy: PropTypes.string
    };

    componentDidMount() {
        if(this.props.initializeStateAndHistory){
            this.props.initializeStateAndHistory({ componentName: 'WindowCleaningFunnel', currentState: this.state });
        }
        FunnelStatePersistance.loadPersistedStateIfNeeded(this);
    }

    serviceType = () => {
        return 'window_cleaning';
    };

    availabilityPathString = () => {
        return 'window_cleaning_availability_path';
    };

    companiesForDatePath = () => {
        return PathHelper('companies_for_date_window_cleaning_requests_path');
    };

    attributesPath = () => {
        return PathHelper('attributes_window_cleaning_requests_path');
    };

    extraServiceTypes = () => {
        return ['bathroom_cleaning', 'carpet_and_upholstery_cleaning', 'oven_cleaning']
    };
}


WindowCleaningFunnel = withLoader(WindowCleaningFunnel);
WindowCleaningFunnel = withPhoneCollector(WindowCleaningFunnel);
WindowCleaningFunnel = withHistory(WindowCleaningFunnel);

class AuthenticatingWindowCleaningFunnel extends React.Component {
    render() {
        return (
            <Authenticator status={this.props.componentProps.authenticationStatus}
                           omniauthError={this.props.componentProps.omniauthError}
                           component={WindowCleaningFunnel}
                           {...this.props} />
        );
    }
}

export default AuthenticatingWindowCleaningFunnel;
